<adapt-dismissible-cta [ctaStyle]="2"
                       [flag]="PersonFlag.ThemePromptDismissed">
    <h1 adapt-cta-title>Explore Lumia's new themes: Green and Burgundy.</h1>

    <button adapt-cta-action
            data-tour="personal-dashboard-tour-cta"
            class="btn btn-primary px-4"
            (click)="setTheme()">
        Set my theme
        <i class="fal fa-fw fa-arrow-right ms-2"></i>
    </button>

    <div>
        <br />
        Click the button to the right, or go to your personal configuration to set your preferred theme.
    </div>
</adapt-dismissible-cta>
